export default "__VITE_ASSET__Ckd3vThK__"